var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 13.6668C0.966667 13.6668 0.652667 13.5364 0.391333 13.2755C0.130444 13.0142 0 12.7002 0 12.3335V3.00016H1.33333V12.3335H8.66667V13.6668H1.33333ZM4 11.0002C3.63333 11.0002 3.31956 10.8697 3.05867 10.6088C2.79733 10.3475 2.66667 10.0335 2.66667 9.66683V1.66683C2.66667 1.30016 2.79733 0.986163 3.05867 0.724829C3.31956 0.46394 3.63333 0.333496 4 0.333496H10C10.3667 0.333496 10.6807 0.46394 10.942 0.724829C11.2029 0.986163 11.3333 1.30016 11.3333 1.66683V9.66683C11.3333 10.0335 11.2029 10.3475 10.942 10.6088C10.6807 10.8697 10.3667 11.0002 10 11.0002H4ZM4 9.66683H10V1.66683H4V9.66683Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.9cd498171c34094fa0e0fec81a321d91.svg";
export { ForwardRef as ReactComponent };